export default function GreyCheckMarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        d="M1 4.27859C1.70294 5.02414 2.8 6.18768 2.8 6.18768L7 1.18768"
        stroke="#6D7184"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
